import { render, staticRenderFns } from "./waitDealReissue.vue?vue&type=template&id=527a2d3f&scoped=true&"
import script from "./waitDealReissue.vue?vue&type=script&lang=js&"
export * from "./waitDealReissue.vue?vue&type=script&lang=js&"
import style0 from "./waitDealReissue.vue?vue&type=style&index=0&id=527a2d3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a2d3f",
  null
  
)

export default component.exports